import _createForOfIteratorHelper from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _cloneDeep from "lodash/cloneDeep";
import _isEqual from "lodash/isEqual";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, toHandlers as _toHandlers, mergeProps as _mergeProps } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "disabled-option"
};
var _hoisted_2 = {
  key: 1
};
import { ElSelect, ElTree } from 'element-plus';
import 'element-plus/es/components/select/style/css'
import 'element-plus/es/components/tree/style/css'


import { ref, onMounted, watch } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XTreeSelect',
  props: {
    modelValue: {
      type: [Array, String, Number, Boolean, Object]
    },
    value: {
      type: [Array, String, Number, Boolean, Object]
    },
    options: {
      default: function _default() {
        return [];
      }
    },
    adapter: {
      type: Function,
      default: function _default(option) {
        return option;
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    autoExpandCheckedNode: {
      type: Boolean,
      default: false
    },
    includeHalfCheckedNode: {
      type: Boolean,
      default: true
    },
    placeholder: {},
    noDataText: {
      default: '暂无数据'
    },
    clearable: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'select'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var prop = __props;
    var emit = __emit;
    var selectOptions = ref([]);
    var treeOptions = ref([]);
    var list = ref([]);
    var treeRef = ref();
    var selectRef = ref();
    onMounted(function () {
      loadTreeOptions(prop.options);
    });
    watch(function () {
      return prop.options;
    }, function (val) {
      loadTreeOptions(val);
    });
    watch(function () {
      return prop.value;
    }, function (val) {
      if (!_isEqual(val, prop.modelValue)) {
        refreshTreeCheckState();
      }
    });
    function handleSelectChange() {
      refreshTreeCheckState();
    }
    function handleSelectVisibleChange(visible) {
      if (visible) {
        expandCheckedNode();
      }
    }
    function handleNodeClick(data) {
      if (data.disabled) {
        return;
      }
      if (!prop.multiple) {
        setSelectedOptions([data.value]);
        closeDropdown();
        emitOptionSelected([_cloneDeep(data)]);
        selectOptions.value.push(data);
      }
    }
    function handleCheckChange() {
      if (prop.multiple && treeRef.value) {
        var checked = _toConsumableArray(treeRef.value.getCheckedKeys());
        if (prop.includeHalfCheckedNode) {
          checked.push.apply(checked, _toConsumableArray(treeRef.value.getHalfCheckedKeys()));
        }
        setSelectedOptions(checked);
        var nodes = treeRef.value.getCheckedNodes(false, prop.includeHalfCheckedNode);
        emitOptionSelected(nodes ? _cloneDeep(nodes) : []);
      }
    }
    function setSelectedOptions(optionsValue) {
      if (!optionsValue || optionsValue.length < 1) {
        clearSelectedOptions();
        return;
      }
      if (prop.multiple) {
        emit('update:modelValue', optionsValue);
      } else {
        emit('update:modelValue', optionsValue[0]);
      }
    }
    function clearSelectedOptions() {
      if (prop.multiple) {
        // this.$emit('update:modelValue', [])
      } else {
        // this.$emit('update:modelValue', undefined)
      }
    }
    function closeDropdown() {
      var _selectRef$value;
      (_selectRef$value = selectRef.value) === null || _selectRef$value === void 0 || _selectRef$value.handleClose();
    }
    function loadTreeOptions(options) {
      var _treeOptions$value, _selectOptions$value;
      list.value = [];
      treeOptions.value = [];
      selectOptions.value = [];
      if (!options || options.length < 1) {
        return;
      }
      var opt = adaptTreeOptions(options);
      (_treeOptions$value = treeOptions.value).push.apply(_treeOptions$value, _toConsumableArray(opt));
      (_selectOptions$value = selectOptions.value).push.apply(_selectOptions$value, _toConsumableArray(list.value));
      refreshTreeCheckState();
    }
    function adaptTreeOptions(options) {
      if (!options) {
        return [];
      }
      var result = [];
      var _iterator = _createForOfIteratorHelper(options),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var option = _step.value;
          var adapted = prop.adapter(option);
          if (adapted.children) {
            adapted.children = adaptTreeOptions(adapted.children);
          }
          list.value.push(adapted);
          result.push(adapted);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return result;
    }
    function refreshTreeCheckState() {
      if (prop.multiple && treeOptions.value && treeOptions.value.length > 0) {
        var selected = prop.modelValue;
        if (selected && selected.length > 0) {
          setTreeCheckedValues(selected);
        } else {
          clearTreeCheckState();
        }
      }
    }
    function expandCheckedNode() {
      var _treeRef$value;
      if (!prop.autoExpandCheckedNode) {
        return;
      }
      var checkedNodes = (_treeRef$value = treeRef.value) === null || _treeRef$value === void 0 ? void 0 : _treeRef$value.getCheckedNodes(false, true);
      if (checkedNodes && checkedNodes.length > 0) {
        var _iterator2 = _createForOfIteratorHelper(checkedNodes),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _treeRef$value2;
            var node = _step2.value;
            expandParentNode((_treeRef$value2 = treeRef.value) === null || _treeRef$value2 === void 0 ? void 0 : _treeRef$value2.getNode(node));
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
    function expandParentNode(node) {
      if (!node) {
        return;
      }
      var parent = node.parent;
      if (!parent || parent.expanded) {
        return;
      }
      parent.expanded = true;
      expandParentNode(parent);
    }
    function setTreeCheckedValues(values) {
      var _treeRef$value3;
      (_treeRef$value3 = treeRef.value) === null || _treeRef$value3 === void 0 || _treeRef$value3.setCheckedKeys(values);
    }
    function clearTreeCheckState() {
      var _treeRef$value4;
      (_treeRef$value4 = treeRef.value) === null || _treeRef$value4 === void 0 || _treeRef$value4.setCheckedKeys([]);
    }
    function emitOptionSelected(options) {
      emit('select', options);
    }
    return function (_ctx, _cache) {
      var _component_el_option = _resolveComponent("el-option");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_unref(ElSelect), _mergeProps({
        style: {
          "width": "100%"
        },
        ref_key: "selectRef",
        ref: selectRef,
        "model-value": _ctx.modelValue,
        multiple: _ctx.multiple,
        loading: _ctx.loading,
        placeholder: _ctx.placeholder,
        clearable: _ctx.clearable,
        "collapse-tags": _ctx.collapseTags
      }, _toHandlers(_ctx.$attrs), {
        onChange: handleSelectChange,
        onVisibleChange: handleSelectVisibleChange
      }), {
        default: _withCtx(function () {
          return [_createVNode(_component_el_option, {
            key: "XTreeSelect-hidden-option",
            label: "XTreeSelect-hidden-option",
            value: "XTreeSelect-hidden-option",
            disabled: "",
            style: {
              "height": "auto",
              "background": "white",
              "padding": "0"
            }
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(ElTree), {
                ref_key: "treeRef",
                ref: treeRef,
                data: _unref(treeOptions),
                "node-key": "value",
                "empty-text": _ctx.noDataText,
                "show-checkbox": _ctx.multiple,
                "expand-on-click-node": _ctx.multiple,
                "check-strictly": _ctx.multiple && _ctx.flat,
                style: {
                  "margin": "6px"
                },
                onNodeClick: handleNodeClick,
                onCheck: handleCheckChange
              }, {
                default: _withCtx(function (_ref2) {
                  var node = _ref2.node,
                    data = _ref2.data;
                  return [_ctx.$slots.default ? _renderSlot(_ctx.$slots, "default", {
                    key: 0,
                    node: node,
                    option: data
                  }) : (_openBlock(), _createElementBlock(_Fragment, {
                    key: 1
                  }, [node.disabled ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(node.label), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(node.label), 1))], 64))];
                }),
                _: 3
              }, 8, ["data", "empty-text", "show-checkbox", "expand-on-click-node", "check-strictly"])];
            }),
            _: 3
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectOptions), function (option) {
            return _withDirectives((_openBlock(), _createBlock(_component_el_option, {
              key: option.value,
              value: option.value,
              label: option.label
            }, null, 8, ["value", "label"])), [[_vShow, false]]);
          }), 128))];
        }),
        _: 3
      }, 16, ["model-value", "multiple", "loading", "placeholder", "clearable", "collapse-tags"])]);
    };
  }
});